import axios from '../../utils/axios';

export const createTeam = async (partnerId, data) => {
  const response = await axios.post(
    `/partners/${partnerId}/teams`,
    data
  );
  return response.data;
};
